<template>
  <section style="width: 100%;height: 100%;background: #fff;position: relative;">
    <header class="header margin-auto" style="height: 100px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 1200px;
    margin: 0 auto;">
      <div>
        <h2 style="    font-size: 28px;
    color: rgb(255, 168, 37);display: block;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;">特资信大模型·特殊资产价值智评系统-用户注册</h2>
      </div>
      <div style="line-height: 34px">
      <router-link to="/" style="float:left;"><div  style="width: 108px;height: 34px;line-height: 34px;text-align: center;background: rgb(255, 168, 37);border: 1px solid rgb(255, 168, 37);
    color: #fff;font-size: 14px;cursor: pointer;font-weight: 600">回到首页</div></router-link>
      <router-link to="/login" style="float:left;margin-left: 20px">已有账号，立即登录</router-link>
      </div>
    </header>

   <div class="reg-info">
    <a-spin tip="数据提交中..." :spinning="spinning">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
        <a-form-item label="用户名">
          <a-input  placeholder="请输入您的用户名"
              v-decorator="['uccode', { rules: [{ required: true, message: '请输入您的用户名' },
              {validator: this.handleNameCheck}],trigger:'blur' }]"
          />
        </a-form-item>
<!--        <a-form-item label="企业全称">-->
<!--          <a-input placeholder="请输入企业法定全称"-->
<!--              v-decorator="['oname', { rules: [{ required: true, message: '请输入企业全称' }] }]"-->
<!--          />-->
<!--        </a-form-item>-->
<!--        <a-form-item label="法定代表人姓名">-->
<!--          <a-input-->
<!--              v-decorator="['pname', { rules: [{ required: true, message: '请输入法定代表人姓名' }] }]"-->
<!--          />-->
<!--        </a-form-item>-->
        <a-form-item label="邮箱">
          <a-input placeholder="请输入邮箱地址"
              v-decorator="['email', { rules: [{ required: true, message: '请输入邮箱', },
              {validator: this.handleEmailCheck}] ,trigger:'blur'}]"
          />
        </a-form-item>
<!--        <a-form-item label="通讯地址">-->
<!--          <a-input-->
<!--              v-decorator="['address']"-->
<!--          />-->
<!--        </a-form-item>-->
        <a-form-item label="登录密码">
          <a-input-password v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }] ,trigger:'blur'}]"
                            placeholder="请输入密码"/>
        </a-form-item>
        <a-form-item label="确认密码">
          <a-input-password
              v-decorator="['password2', { rules: [{ required: true, message: '请再次输入密码' },
              { validator: this.handlePasswordCheck }],trigger:'blur' }]"
              placeholder="请输入确认密码"/>
        </a-form-item>
        <a-form-item label="电话号码">
          <a-input placeholder="请输入电话号码"
                   v-decorator="['phone', { rules: [{ required: true, message: '请输入电话号码' },
                   {validator: this.handlePhoneCheck}] ,trigger:'blur'}]"
          />
        </a-form-item>
        <a-form-item label="图形验证码">
          <a-input
              v-decorator="['inputCode',{ rules: [{ required: true, message: '请输入图形验证码' }] }]"
              size="large"
              type="text"
              style="width: 180px;margin-right: 15px"
              @change="inputCodeChange"
              placeholder="请输入图形验证码">
            <a-icon slot="prefix" type="smile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
          </a-input>
          <img v-if="requestCodeSuccess" :src="randCodeImage" @click="handleChangeCheckCode"/>
          <img v-else src="../../assets/checkcode.png" @click="handleChangeCheckCode"/>

        </a-form-item>
            <a-form-item label="短信验证码" >
              <a-input style="width: 180px"
                  v-decorator="['smsCode',{initialValue:'', rules:validatorRules.captcha.rules}]"
                  size="large"
                  type="text"
                  placeholder="请输入短信验证码">
                <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
              </a-input>
              <a-button
                  class="getCaptcha"
                  tabindex="-1"
                  :disabled="state.smsSendBtn"
                  @click.stop.prevent="getCaptcha"
                  v-text="!state.smsSendBtn && '获取验证码' || (state.time+' s')">
              </a-button>
            </a-form-item>


<!--        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">-->
<!--          <a-checkbox :checked="!consent" @change="onChange"></a-checkbox>-->
<!--          我已阅读并同意<a @click="showAgreement">《供应链企业信用管理平台用户服务协议》</a>-->
<!--        </a-form-item>-->
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button :disabled="consent" style="width: 150px;background: rgb(255, 168, 37);border: rgb(255, 168, 37);color: white;font-weight: 400" type="danger" html-type="submit">
            注册
          </a-button>
        </a-form-item>
      </a-form>
    </a-spin>
    <agreement ref="agr" @ok="qr"></agreement>
  </div>

<!--    <footer style="height: 44px;background: #666;">-->
<!--      <div style="    height: 100%;-->
<!--    overflow: hidden;-->
<!--    display: -webkit-box;-->
<!--    display: -ms-flexbox;-->
<!--    display: flex;-->
<!--    -webkit-box-align: center;-->
<!--    -ms-flex-align: center;-->
<!--    align-items: center;-->
<!--    font-size: 12px;-->
<!--    font-weight: 400;-->
<!--    color: #fff;-->
<!--width: 1200px;-->
<!--    margin: 0 auto;">-->
<!--        <ul style="    display: -webkit-box;-->
<!--    display: -ms-flexbox;-->
<!--    display: flex;-->
<!--    -webkit-box-align: center;-->
<!--    -ms-flex-align: center;-->
<!--    align-items: center;-->
<!--    margin-right: 70px;-->
<!--    margin-bottom: 0em;">-->
<!--          <li>-->
<!--            <router-link to="/legaldec" >-->
<!--              <span  style="cursor: pointer;text-decoration: none;color:rgb(255 255 255);"> 法律声明 </span>-->
<!--            </router-link>-->
<!--          </li>-->
<!--          <li style="width: 1px;height: 10px;background: #fff; margin: 0 12px;"></li>-->
<!--          <li>-->
<!--            <router-link to="/contact">-->
<!--              <span style="cursor: pointer;text-decoration: none;color: rgb(255 255 255);"> 联系我们 </span>-->
<!--            </router-link>-->
<!--          </li>-->
<!--          <li style="width: 1px;height: 10px;background: #fff; margin: 0 12px;"></li>-->
<!--          <li>-->
<!--            <router-link to="/about">-->
<!--              <span style="cursor: pointer;text-decoration: none;color: rgb(255 255 255);"> 平台介绍 </span>-->
<!--            </router-link>-->
<!--          </li>-->
<!--        </ul>-->
<!--        <span style="-webkit-box-flex: 1;-->
<!--    -ms-flex: 1;-->
<!--    flex: 1;-->
<!--    text-align: right;">©2023 供应链企业信用管理平台  <a href="https://beian.miit.gov.cn/" style="color: #FFFFFF" target="_blank"> 粤ICP备2023133949号 </a></span>-->
<!--      </div>-->
<!--    </footer>-->
  </section>

</template>

<script>
import {getAction, postAction} from "@/api/manage";
import Agreement from "@/views/register/Agreement";

export default {
  name: "register",
  components: {
    Agreement
  },
  data() {
    return {
      form: this.$form.createForm(this),
      inputCodeContent: '',
      requestCodeSuccess: false,
      randCodeImage: '',
      currdatetime: '',
      consent: false,
      spinning:false,
      validatorRules: {
        captcha: {rules: [{required: true, message: '请输入短信验证码!'}]},
      },
      state: {
        time: 60,
        smsSendBtn: false,
      },
    };
  },
  created() {
    this.currdatetime = new Date().getTime();
    this.handleChangeCheckCode();
  },
  methods: {
    handleBlur(){
      this.form.validateFields(['email']);
    },
    qr(){
      this.consent = false;
    },
    showAgreement() {
      //this.$refs.agr.show();
      let routeData = this.$router.resolve({path: '/userAgreement'});
      window.open(routeData.href, '_blank');
    },
    onChange(e) {
      if (e.target.checked) {
        this.consent = false;
      } else {
        this.consent = true;
      }
    },
    inputCodeChange(e) {
      this.inputCodeContent = e.target.value
    },
    handleChangeCheckCode() {
      this.currdatetime = new Date().getTime();
      getAction(`/user/randomImage/${this.currdatetime}`).then(res => {
        if (res.success) {
          this.randCodeImage = res.data.imgCode;
          this.requestCodeSuccess = true
        } else {
          this.$message.error(res.message)
          this.requestCodeSuccess = false
        }
      }).catch(() => {
        this.requestCodeSuccess = false
      })
    },
    handleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.spinning=true;
          let param = Object.assign({}, values);
          param.checkKey = this.currdatetime
          postAction('/user/register', param).then((res) => {
            if (res.success) {
              this.spinning=false;
              this.$message.success('注册成功!')
              this.form.resetFields();
              //this.$router.push('/login')
            } else {
              this.spinning=false;
              this.$message.warning(res.message)
            }
          });
        }
      });
    },
    handlePasswordCheck(rule, value, callback) {
      let password = this.form.getFieldValue('password')
      if (value === undefined) {
        callback(new Error('请输入密码'))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'))
      }
      callback()
    },
    handleEmailCheck(rule, value, callback) {
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (!regEmail.test(value)) {
        callback(new Error('邮箱格式不正确'))
      }
      callback()
    },
    handleNameCheck(rule, value, callback){
      const nameReg = /^[A-Za-z0-9]+$/;
      // if (!nameReg.test(value)) {
      //   callback(new Error('用户名必须为字母或数字'))
      // }
      if(value.length<6){
        callback(new Error('长度大于6位'))
      }
      callback()
    },
    handlePhoneCheck(rule, value, callback) {
      const regMobile = /^((\d{3,4}-)?\d{7,8})|((\d{3,4}\-)?\d{7,8}\-\d{3,4}\-?)*\d{7,8}$/;
      if (!regMobile.test(value)) {
        callback(new Error('电话号码格式不正确'))
      }
      callback()
    },
    getCaptcha(e) {
      e.preventDefault();
      let that = this;
      this.form.validateFields(['phone', 'inputCode'], {force: true}, (err, values) => {
            if (!values.phone) {
              this.$message.error("请输入手机号！");
            } else if (!values.inputCode) {
              this.$message.error("请输入图形验证码！");
            } else if (!err) {
              this.state.smsSendBtn = true;
              let interval = window.setInterval(() => {
                if (that.state.time-- <= 0) {
                  that.state.time = 60;
                  that.state.smsSendBtn = false;
                  window.clearInterval(interval);
                }
              }, 1000);

              let smsParams = {};
              smsParams.mobile = values.phone;
              smsParams.checkKey = that.currdatetime;
              smsParams.inputCode = values.inputCode;
              postAction("/user/sendRegisterSms", smsParams)
                  .then(res => {
                    if (!res.success) {
                      clearInterval(interval);
                      this.$message.error(res.message);
                      that.state.time = 60;
                      that.state.smsSendBtn = false;
                    } else {
                      this.$message.success('验证码发送成功');
                    }

                  })
                  .catch(err => {
                    clearInterval(interval);
                    that.state.time = 60;
                    that.state.smsSendBtn = false;
                    this.$message.error(err)
                  });
            }
          }
      );
    },
  },
};
</script>
<style scoped>
.reg-info {
  width: 1200px;
  margin: 20px auto;
  background: #fbfbfb;
  padding-top: 50px;
  padding-bottom: 140px;
}

.getCaptcha {
  width: 20%;
  height: 40px;
  margin-left: 10px;
}
</style>
